import jQuery from 'jquery';

// import 'swiper/css';
// import 'swiper/css/pagination';
// import 'swiper/css/effect-fade';
// import Swiper, { Pagination, Autoplay, EffectFade } from 'swiper';

import Swiper from 'swiper/bundle';
// Swiper.use([Pagination, Autoplay, EffectFade]);
import 'swiper/css/bundle';
const myDelay = 5000;
const slider = {
	alpha: document.querySelector('.m-slider_01'),
	bravo: document.querySelector('.m-swiper_pager'),
	charlie: document.querySelector('.m-slider_02'),
	delta: document.querySelector('.m-slider_03'),
};
// export let mySwiper;
export let set_remove;
// export let mainSlider = null;
export let mainSlider = new Swiper('.mv05 .swiper', {
		init: false,
	});
// export const mainSlider = new Swiper('.mv05 .swiper', {
// 	init: false,
// 	loop: true,
// 	loopAdditionalSlides: 1,
// 	// speed: 3000,
// 	speed: 1666, //.mv05 .slide-media imgの変更も必要
// 	autoplay: {
// 		delay: myDelay,
// 		disableOnInteraction: false,
// 		waitForTransition: false,
// 	},
// 	followFinger: false,
// 	observeParents: true,
// 	on: {},
// });
export function top_swiper() {
	// console.log('top_swiper');

	let removeFlag = true;

	// 円形バー
	const slide = document.querySelectorAll('.mv05 .swiper-slide');
	const slideLength = slide.length;
	// const fraction = document.getElementById('js-fraction');
	const fraction = document.querySelectorAll('.mv05 .slide-fraction');
	const fractionEl =
		'<span class="circle"><svg viewBox="0 0 354 354"><circle class="circle-01" cx="50%" cy="50%" r="162"></circle><circle class="circle-02" cx="50%" cy="50%" r="176"></circle></svg></span>';
	// fraction.insertAdjacentHTML('beforeend', fractionEl);
	// fraction.querySelector('.circle-02').style.animationDuration = myDelay + 'ms';
	for (let i = 0; i < fraction.length; i++) {
		fraction[i].insertAdjacentHTML('beforeend', fractionEl);
		fraction[i].querySelector('.circle-01').style.animationDuration =
			myDelay + 'ms';
		fraction[i].querySelector('.circle-02').style.animationDuration =
			myDelay + 'ms';
	}
	// 各スライドの表示時間とアニメーションを連動
	// const slideDelay = [];
	// for (let i = 0; i < slideLength; i++) {
	// 		// HTML側の data-swiper-autoplay を取得
	// 		let delay = Number(slide[i].getAttribute('data-swiper-autoplay'));
	// 		slideDelay[i] = delay ? delay : myDelay; // HTMLに指定がなければ myDelay をセット

	// 		// 各タグに transitionDuration / animationDuration をセット
	// 		// slide[i].querySelector('.slide-media').style.transitionDuration =
	// 		// slideDelay[i] + 'ms';
	// 	}

	// // プログレスバーの更新処理
	// const progressBar = document.querySelector('.mv05 .progressbar-fill');
	// const updateProgress = (index) => {
	// 	let start = Math.floor((index / slideLength) * 100) / 100;
	// 	let end = Math.floor(((index + 1) / slideLength) * 100) / 100;

	// 	// 一度スタートの位置に移動してから
	// 	progressBar.style.transition = '';
	// 	progressBar.style.transform = 'scaleX(' + start + ')';
	// 	setTimeout(() => {
	// 		// ゴールの位置まで伸ばす
	// 		progressBar.style.transition = slideDelay[index] + 'ms linear';
	// 		progressBar.style.transform = 'scaleX(' + end + ')';
	// 	}, 100);
	// };

	const startAnimation = (index) => {
		if ($('.mv05').length) {
			let activeSlide = document.querySelectorAll('.mv05 .content')[index];
			activeSlide.classList.remove('anm-finished');
			activeSlide.classList.add('anm-started');
		}
	};

	const finishAnimation = () => {
		if ($('.mv05').length) {
			let activeSlide = document.querySelector('.mv05 .content.anm-started');
			if (activeSlide) {
				activeSlide.classList.remove('anm-started');
				activeSlide.classList.add('anm-finished');
			}
		}
	};

	const mainSlider = new Swiper('.mv05 .swiper', {
		loop: true,
		loopAdditionalSlides: 1,
		// speed: 3000,
		speed: 1666, //.mv05 .slide-media imgの変更も必要
		autoplay: {
			delay: myDelay,
			disableOnInteraction: false,
			waitForTransition: false,
			// reverseDirection: false, // 逆方向有効化
		},
		followFinger: false,

		
		observer: true, 
		observeParents: true,
		// centeredSlides: true,
		on: {
			init: function () {
			  console.log('Swiper initialized');
			 },
		  },
	});
	mainSlider.on('slideChangeTransitionEnd', function () {});
	mainSlider.on('slideChange', (swiper) => {
		finishAnimation();
		$('.m-swiper_pager .swiper-slide').removeClass('sw-slide-active');
		$('.m-swiper_pager .swiper-slide')
			.eq(swiper.realIndex)
			.addClass('sw-slide-active');
	});
	mainSlider.on('slideChangeTransitionStart', (swiper) => {
		startAnimation(swiper.realIndex);
		$('.content.js-circle-active').removeClass('js-circle-active');
		$('.content-wrapper .content')
			.eq(swiper.realIndex)
			.addClass('js-circle-active');
	});
	mainSlider.on('slideChangeTransitionEnd', (swiper) => {});

	$('.js-menu-toggle').on('click', (e) => {
		if (!$('.js-menu_active').length) {
			var index = mainSlider.realIndex;
			console.log('index', index);
			mainSlider.slideToLoop(index + 1);
			// mainSlider.slideNext();
		}
	});

	$('.m-swiper_pager .swiper-slide').on('click', (e) => {
		$('#js-fraction').removeClass('js-circle-active');
		var index = $('.m-swiper_pager .swiper-slide').index(e.currentTarget);
		mainSlider.slideToLoop(index);
	});
}

export function top_swiper_destroy(e) {
	// e.destroy(false, true);
	e.disable()
}
//aboutページswiper
let achiev_slider;
export function about_swiper() {
	// achiev_slider = new Swiper(document.querySelector('.m-slider_02'), {
	// 	init: false,
	// 	slidesPerView: 1,
	// 	updateOnImagesReady: false,
	// 	loop: true,
	// 	autoplay: { delay: 3000, disableOnInteraction: false },
	// 	pagination: {
	// 		el: '.swiper-pagination',
	// 		clickable: true,
	// 		type: 'bullets',
	// 	},
	// });
	// let achiev_slider02 = new Swiper(document.querySelector('.m-slider_03'), {
	// 	init: false,
	// 	slidesPerView: 1,
	// 	updateOnImagesReady: false,
	// 	loop: true,
	// 	autoplay: { delay: 3000, disableOnInteraction: false },
	// 	pagination: {
	// 		el: '.swiper-pagination',
	// 		clickable: true,
	// 		type: 'bullets',
	// 	},
	// });
	// achiev_slider.init();
	// achiev_slider02.init();
	// $('.m-slider_02').on('mouseenter', function (e) {
	// 	achiev_slider.autoplay.stop();
	// });
	// $('.m-slider_02').on('mouseleave', function (e) {
	// 	achiev_slider.autoplay.start();
	// });
	// $('.m-slider_03').on('mouseenter', function (e) {
	// 	achiev_slider02.autoplay.stop();
	// });
	// $('.m-slider_03').on('mouseleave', function (e) {
	// 	achiev_slider02.autoplay.start();
	// });
}
